import React from "react";
import {Link} from "react-router-dom";

const TopbarNav = () => {

    const logout = () => {
        if (window.confirm('¿Estás seguro que deseas cerrar la sesión?')) {
            localStorage.clear();
            window.location.reload();
        }
    };

    return (
        <nav className="navbar navbar-expand-lg bg-gradient box-shadow" data-bs-theme="dark">
            <div className="container-fluid">
                <Link className="navbar-brand" to="/">
                    <img src="/logo.png" className="logo-login-top logo-top-card" alt="GeoTrace" />
                </Link>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarColor02"
                        aria-controls="navbarColor02" aria-expanded="false" aria-label="Toggle navigation">
                    <span className="navbar-toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse" id="navbarColor02">
                    <ul className="navbar-nav me-auto">
                        <li className="nav-item">
                            <Link className="nav-link active" to="/dashboard">Home
                                <span className="visually-hidden">(current)</span>
                            </Link>
                        </li>
                        <li className="nav-item">
                            <Link className="nav-link" to="/clientes">Clientes</Link>
                        </li>
                    </ul>
                    <div className="d-flex">
                        <button className="logout-btn btn w-100 btn-dark-transparent" onClick={logout}>Cerrar sesión</button>
                    </div>
                </div>
            </div>
        </nav>
    );
}

export default TopbarNav;